module.exports = __webpack_public_path__ + "cx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cx.svg
// module id = 509
// module chunks = 0